import { render, staticRenderFns } from "./SOV.vue?vue&type=template&id=bc78568e&scoped=true"
import script from "./SOV.vue?vue&type=script&lang=js"
export * from "./SOV.vue?vue&type=script&lang=js"
import style0 from "./SOV.vue?vue&type=style&index=0&id=bc78568e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc78568e",
  null
  
)

export default component.exports